import { Phone } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY } from "../../lib/site";
import { Reveal, SectionTag } from "./Reveal";

export const PriceCTA = () => (
  <section className="bg-zinc-950 py-20 sm:py-24 relative overflow-hidden" data-testid="price-cta-section">
    <div className="absolute left-0 top-0 h-full w-2 bg-red-700" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionTag number="02" label="Pricing" dark />
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-[1.02] max-w-4xl">
          BEFORE YOU SELL YOUR SCRAP, <span className="text-red-500">CALL SCRAPMAN'S.</span>
        </h2>
        <p className="mt-5 text-zinc-400 text-lg max-w-2xl">
          Scrap prices move with the market. Call us for today's pricing and see what your metal is worth.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-10 flex flex-col lg:flex-row lg:items-center gap-8">
          <a
            href={PHONE_TEL}
            className="font-heading text-5xl sm:text-7xl text-white tracking-wide hover:text-red-500 transition-colors"
            data-testid="price-cta-phone"
          >
            {PHONE_DISPLAY}
          </a>
          <a
            href={PHONE_TEL}
            className="inline-flex items-center justify-center gap-3 bg-red-700 text-white px-8 py-4 font-heading text-lg tracking-wider hover:bg-red-800 transition-colors self-start"
            data-testid="price-cta-call-button"
          >
            <Phone className="h-5 w-5" />
            CALL FOR TODAY'S PRICE
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
